/* The Sleep Co - mattress PDP behaviour
   Handles:
   - Gallery
   - Product options
   - Variant resolution
   - Cross-product feel links
   - Delivery and recycling add-on products
   - AJAX add to cart
   - Native cart drawer refresh
   - Header cart count and price refresh
   - Back-button cart synchronization
   - Sticky add-to-cart bar
*/

(function () {
  'use strict';

  var syncCartInterface = null;

  function initMattressPDP() {
    var dataEl = document.querySelector('[data-kb-data]');

    if (!dataEl) return;

    if (
      dataEl.getAttribute('data-kb-initialized') ===
      'true'
    ) {
      return;
    }

    dataEl.setAttribute(
      'data-kb-initialized',
      'true'
    );

    var DATA;

    try {
      DATA = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error(
        '[Knightsbridge] Could not read product data.',
        error
      );
      return;
    }

    var form =
      document.getElementById('kb-form');

    var idInput =
      document.querySelector(
        '[data-kb-variant-id]'
      );

    var priceEl =
      document.querySelector(
        '[data-kb-price]'
      );

    var compareEl =
      document.querySelector(
        '[data-kb-compare]'
      );

    var financeEl =
      document.querySelector(
        '[data-kb-finance]'
      );

    var submitBtn =
      document.querySelector(
        '[data-kb-submit]'
      );

    var submitTxt =
      document.querySelector(
        '[data-kb-submit-text]'
      );

    var totalEl =
      document.querySelector(
        '[data-kb-total]'
      );

    var stick =
      document.querySelector(
        '[data-kb-stick]'
      );

    var stickMeta =
      document.querySelector(
        '[data-kb-stick-meta]'
      );

    var stickPrice =
      document.querySelector(
        '[data-kb-stick-price]'
      );

    var addonBox =
      document.querySelector(
        '[data-kb-addons]'
      );

    var recycle =
      document.querySelector(
        '[data-kb-recycle]'
      );

    var optionGroups =
      Array.prototype.slice.call(
        document.querySelectorAll(
          '[data-kb-option-index]'
        )
      );

    var isAddingToCart = false;

    /* ========================================
       SHOPIFY ROOT
    ======================================== */

    function getShopifyRoot() {
      if (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      ) {
        return window.Shopify.routes.root;
      }

      return '/';
    }

    /* ========================================
       MONEY
    ======================================== */

    function money(cents) {
      var fmt =
        DATA.moneyFormat ||
        '£{{amount}}';

      function formattedValue(
        decimalPlaces,
        commaDecimal
      ) {
        var number =
          (cents / 100).toFixed(
            decimalPlaces
          );

        var parts =
          number.split('.');

        parts[0] =
          parts[0].replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          );

        if (decimalPlaces === 0) {
          return parts[0];
        }

        if (commaDecimal) {
          return (
            parts[0] +
            ',' +
            parts[1]
          );
        }

        return parts.join('.');
      }

      return fmt
        .replace(
          /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
          formattedValue(0, false)
        )
        .replace(
          /\{\{\s*amount_with_comma_separator\s*\}\}/g,
          formattedValue(2, true)
        )
        .replace(
          /\{\{\s*amount_no_decimals\s*\}\}/g,
          formattedValue(0, false)
        )
        .replace(
          /\{\{\s*amount\s*\}\}/g,
          formattedValue(2, false)
        );
    }

    /* ========================================
       CURRENT SELECTION
    ======================================== */

    function selected() {
      return optionGroups.map(
        function (group) {
          var selectedButton =
            group.querySelector(
              '.kb-opt[aria-pressed="true"]'
            );

          return selectedButton
            ? selectedButton.getAttribute(
                'data-kb-value'
              )
            : null;
        }
      );
    }

    function findVariant(
      list,
      options
    ) {
      if (!Array.isArray(list)) {
        return null;
      }

      for (
        var i = 0;
        i < list.length;
        i++
      ) {
        var variant = list[i];
        var matches = true;

        for (
          var j = 0;
          j < options.length;
          j++
        ) {
          if (
            options[j] !== null &&
            variant.options[j] !==
              options[j]
          ) {
            matches = false;
            break;
          }
        }

        if (matches) {
          return variant;
        }
      }

      return null;
    }

    /* ========================================
       AVAILABILITY
    ======================================== */

    function markAvailability() {
      var currentOptions =
        selected();

      optionGroups.forEach(
        function (
          group,
          groupIndex
        ) {
          group
            .querySelectorAll(
              '.kb-opt'
            )
            .forEach(
              function (button) {
                var testOptions =
                  currentOptions.slice();

                testOptions[
                  groupIndex
                ] =
                  button.getAttribute(
                    'data-kb-value'
                  );

                var variant =
                  findVariant(
                    DATA.current
                      .variants,
                    testOptions
                  );

                var isAvailable =
                  Boolean(
                    variant &&
                      variant.available
                  );

                button.setAttribute(
                  'data-kb-unavailable',
                  isAvailable
                    ? 'false'
                    : 'true'
                );

                button.disabled =
                  !isAvailable;
              }
            );
        }
      );
    }

    /* ========================================
       FEEL LINKS
    ======================================== */

    function updateFeelLinks() {
      var currentOptions =
        selected();

      document
        .querySelectorAll(
          '[data-kb-feel-link]'
        )
        .forEach(
          function (link) {
            var handle =
              link.getAttribute(
                'data-handle'
              );

            var sibling =
              DATA.siblings.filter(
                function (item) {
                  return (
                    item.handle ===
                    handle
                  );
                }
              )[0];

            if (!sibling) return;

            var targetVariant =
              findVariant(
                sibling.variants,
                currentOptions
              ) ||
              findVariant(
                sibling.variants,
                [
                  currentOptions[0]
                ]
              );

            link.href =
              targetVariant
                ? sibling.url +
                  '?variant=' +
                  targetVariant.id
                : sibling.url;
          }
        );
    }

    /* ========================================
       ADD-ON TOTAL
    ======================================== */

    function addonTotal() {
      if (!addonBox) return 0;

      var sum = 0;

      addonBox
        .querySelectorAll(
          'input[type="radio"]:checked'
        )
        .forEach(
          function (input) {
            var row =
              input.closest(
                '.kb-radio'
              );

            if (!row) return;

            var priceElement =
              row.querySelector('em');

            if (!priceElement) {
              return;
            }

            var number =
              priceElement.textContent
                .replace(
                  /[^0-9.]/g,
                  ''
                );

            if (number) {
              sum += Math.round(
                parseFloat(number) *
                  100
              );
            }
          }
        );

      return sum;
    }

    /* ========================================
       RENDER PRODUCT
    ======================================== */

    function render() {
      var currentOptions =
        selected();

      var variant =
        findVariant(
          DATA.current.variants,
          currentOptions
        );

      markAvailability();
      updateFeelLinks();

      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
        }

        if (submitTxt) {
          submitTxt.textContent =
            'Unavailable in this combination';
        }

        return;
      }

      if (idInput) {
        idInput.value =
          variant.id;
      }

      if (priceEl) {
        priceEl.textContent =
          money(variant.price);
      }

      if (compareEl) {
        if (
          variant.compare >
          variant.price
        ) {
          compareEl.textContent =
            money(
              variant.compare
            );

          compareEl.hidden =
            false;
        } else {
          compareEl.hidden =
            true;
        }
      }

      if (financeEl) {
        financeEl.textContent =
          money(
            Math.round(
              variant.price /
                (
                  DATA.financeMonths ||
                  6
                )
            )
          );
      }

      if (!isAddingToCart) {
        if (submitBtn) {
          submitBtn.disabled =
            !variant.available;
        }

        if (submitTxt) {
          submitTxt.textContent =
            variant.available
              ? 'Add to bag'
              : 'Unavailable';
        }
      }

      var totalPrice =
        variant.price +
        addonTotal();

      if (totalEl) {
        totalEl.textContent =
          money(totalPrice);
      }

      if (stickPrice) {
        stickPrice.textContent =
          money(totalPrice);
      }

      if (stickMeta) {
        stickMeta.textContent =
          [
            DATA.current.feel,
            variant.title
          ]
            .filter(Boolean)
            .join(' · ');
      }

      if (
        window.history &&
        window.history.replaceState
      ) {
        var url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          'variant',
          variant.id
        );

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      }
    }

    /* ========================================
       PRODUCT OPTION CLICKS
    ======================================== */

    optionGroups.forEach(
      function (group) {
        group.addEventListener(
          'click',
          function (event) {
            var button =
              event.target.closest(
                '.kb-opt'
              );

            if (
              !button ||
              button.disabled
            ) {
              return;
            }

            group
              .querySelectorAll(
                '.kb-opt'
              )
              .forEach(
                function (
                  otherButton
                ) {
                  otherButton.setAttribute(
                    'aria-pressed',
                    'false'
                  );
                }
              );

            button.setAttribute(
              'aria-pressed',
              'true'
            );

            render();
          }
        );
      }
    );

    /* ========================================
       DELIVERY AND RECYCLING
    ======================================== */

    if (addonBox) {
      addonBox.addEventListener(
        'change',
        function () {
          if (recycle) {
            var trigger =
              recycle.getAttribute(
                'data-trigger'
              );

            var selectedDelivery =
              addonBox.querySelector(
                'input[name="kb-delivery"]:checked'
              );

            var selectedLabel =
              selectedDelivery
                ? selectedDelivery.getAttribute(
                    'data-kb-label'
                  )
                : '';

            var showRecycle =
              !trigger ||
              selectedLabel ===
                trigger;

            recycle.hidden =
              !showRecycle;

            if (!showRecycle) {
              var firstRecycleOption =
                recycle.querySelector(
                  'input[type="radio"]'
                );

              if (
                firstRecycleOption
              ) {
                firstRecycleOption.checked =
                  true;
              }
            }
          }

          render();
        }
      );

      addonBox.dispatchEvent(
        new Event('change')
      );
    }

    /* ========================================
       COLLECT CART ITEMS
    ======================================== */

    function collectItems() {
      var currentOptions =
        selected();

      var mainVariant =
        findVariant(
          DATA.current.variants,
          currentOptions
        );

      if (!mainVariant) {
        return null;
      }

      var items = [
        {
          id: Number(
            mainVariant.id
          ),
          quantity: 1
        }
      ];

      if (addonBox) {
        addonBox
          .querySelectorAll(
            'input[type="radio"]:checked'
          )
          .forEach(
            function (input) {
              var addonVariantId =
                parseInt(
                  input.value,
                  10
                );

              if (
                Number.isFinite(
                  addonVariantId
                ) &&
                addonVariantId > 0
              ) {
                items.push({
                  id:
                    addonVariantId,
                  quantity: 1
                });
              }
            }
          );
      }

      return items;
    }

    /* ========================================
       BUTTON STATE
    ======================================== */

    function setButtonState(
      button,
      text,
      disabled
    ) {
      if (!button) return;

      button.disabled =
        disabled;

      var textElement =
        button.querySelector(
          '[data-kb-submit-text]'
        );

      if (textElement) {
        textElement.textContent =
          text;
      } else {
        button.textContent =
          text;
      }
    }

    /* ========================================
       SECTION PARSING
    ======================================== */

    function getSectionInnerHTML(
      html,
      selector
    ) {
      if (
        !html ||
        typeof html !==
          'string'
      ) {
        return '';
      }

      var parsed =
        new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );

      var element =
        parsed.querySelector(
          selector
        );

      return element
        ? element.innerHTML
        : '';
    }

    /* ========================================
       MANUAL CART SYNCHRONIZATION
    ======================================== */

    syncCartInterface =
      function (options) {
        options =
          options || {};

        var root =
          getShopifyRoot();

        var requestUrl =
          root +
          '?sections=' +
          [
            'cart-drawer',
            'cart-icon-bubble',
            'cart-price'
          ].join(',') +
          '&_=' +
          Date.now();

        return fetch(
          requestUrl,
          {
            method: 'GET',

            headers: {
              Accept:
                'application/json',
              'X-Requested-With':
                'XMLHttpRequest'
            },

            cache: 'no-store'
          }
        )
          .then(
            function (response) {
              if (!response.ok) {
                throw new Error(
                  'Cart synchronization failed: ' +
                    response.status
                );
              }

              return response.json();
            }
          )
          .then(
            function (sections) {
              var cartIcon =
                document.getElementById(
                  'cart-icon-bubble'
                );

              if (
                cartIcon &&
                sections[
                  'cart-icon-bubble'
                ]
              ) {
                cartIcon.innerHTML =
                  getSectionInnerHTML(
                    sections[
                      'cart-icon-bubble'
                    ],
                    '.shopify-section'
                  );
              }

              var cartPrice =
                document.getElementById(
                  'cart-price'
                );

              if (
                cartPrice &&
                sections[
                  'cart-price'
                ]
              ) {
                cartPrice.innerHTML =
                  getSectionInnerHTML(
                    sections[
                      'cart-price'
                    ],
                    '.shopify-section'
                  );
              }

              var currentDrawer =
                document.getElementById(
                  'CartDrawer'
                );

              if (
                currentDrawer &&
                sections[
                  'cart-drawer'
                ]
              ) {
                var newDrawerHtml =
                  getSectionInnerHTML(
                    sections[
                      'cart-drawer'
                    ],
                    '#CartDrawer'
                  );

                if (newDrawerHtml) {
                  currentDrawer.innerHTML =
                    newDrawerHtml;
                }
              }

              var cartDrawer =
                document.querySelector(
                  'cart-drawer'
                );

              if (
                options.openDrawer &&
                cartDrawer &&
                typeof cartDrawer.open ===
                  'function'
              ) {
                cartDrawer.open();
              }

              return sections;
            }
          )
          .catch(
            function (error) {
              console.warn(
                '[Knightsbridge] Cart synchronization failed.',
                error
              );

              return null;
            }
          );
      };

    window.KBSyncCartInterface =
      syncCartInterface;

    /* ========================================
       AJAX ADD TO CART
    ======================================== */

    function addToCart(button) {
      if (isAddingToCart) {
        return;
      }

      var items =
        collectItems();

      if (
        !items ||
        !items.length ||
        !button
      ) {
        return;
      }

      isAddingToCart = true;

      setButtonState(
        button,
        'Adding',
        true
      );

      if (
        submitBtn &&
        submitBtn !== button
      ) {
        setButtonState(
          submitBtn,
          'Adding',
          true
        );
      }

      var root =
        getShopifyRoot();

      var cartDrawer =
        document.querySelector(
          'cart-drawer'
        );

      var sectionsToRender =
        cartDrawer &&
        typeof cartDrawer.getSectionsToRender ===
          'function'
          ? cartDrawer
              .getSectionsToRender()
              .map(
                function (
                  section
                ) {
                  return section.id;
                }
              )
          : [
              'cart-drawer',
              'cart-icon-bubble',
              'cart-price'
            ];

      /*
        Ensure every section required by this
        theme is always requested.
      */
      [
        'cart-drawer',
        'cart-icon-bubble',
        'cart-price'
      ].forEach(
        function (sectionId) {
          if (
            sectionsToRender.indexOf(
              sectionId
            ) === -1
          ) {
            sectionsToRender.push(
              sectionId
            );
          }
        }
      );

      fetch(
        root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'
          },

          body: JSON.stringify({
            items: items,

            sections:
              sectionsToRender,

            sections_url:
              window.location.pathname +
              window.location.search
          })
        }
      )
        .then(
          function (response) {
            return response
              .json()
              .then(
                function (body) {
                  return {
                    ok:
                      response.ok,

                    status:
                      response.status,

                    body:
                      body
                  };
                }
              );
          }
        )
        .then(
          function (result) {
            if (!result.ok) {
              throw new Error(
                result.body
                  .description ||
                  result.body
                    .message ||
                  'Could not add to bag'
              );
            }

            /*
              Use the theme's own cart-drawer method.
              It updates:
              - #CartDrawer
              - #cart-icon-bubble
              - #cart-price
              and then opens the drawer.
            */
            try {
              var currentCartDrawer =
                document.querySelector(
                  'cart-drawer'
                );

              if (
                currentCartDrawer &&
                typeof currentCartDrawer
                  .renderContents ===
                  'function'
              ) {
                currentCartDrawer
                  .renderContents(
                    result.body
                  );
              } else {
                syncCartInterface({
                  openDrawer: true
                });
              }
            } catch (
              cartRefreshError
            ) {
              console.warn(
                '[Knightsbridge] Products were added, but native cart refresh failed.',
                cartRefreshError
              );

              syncCartInterface({
                openDrawer: true
              });
            }

            setButtonState(
              button,
              'Added',
              true
            );

            if (
              submitBtn &&
              submitBtn !== button
            ) {
              setButtonState(
                submitBtn,
                'Added',
                true
              );
            }

            document.dispatchEvent(
              new CustomEvent(
                'kb:cart:added',
                {
                  detail:
                    result.body
                }
              )
            );

            window.setTimeout(
              function () {
                isAddingToCart =
                  false;

                setButtonState(
                  button,
                  'Add to bag',
                  false
                );

                if (
                  submitBtn &&
                  submitBtn !==
                    button
                ) {
                  setButtonState(
                    submitBtn,
                    'Add to bag',
                    false
                  );
                }

                render();
              },
              1800
            );
          }
        )
        .catch(
          function (error) {
            console.error(
              '[Knightsbridge cart]',
              error
            );

            isAddingToCart =
              false;

            setButtonState(
              button,
              'Could not add to bag',
              true
            );

            if (
              submitBtn &&
              submitBtn !== button
            ) {
              setButtonState(
                submitBtn,
                'Could not add to bag',
                true
              );
            }

            window.setTimeout(
              function () {
                setButtonState(
                  button,
                  'Add to bag',
                  false
                );

                if (
                  submitBtn &&
                  submitBtn !==
                    button
                ) {
                  setButtonState(
                    submitBtn,
                    'Add to bag',
                    false
                  );
                }

                render();
              },
              2600
            );
          }
        );
    }

    /* ========================================
       PREVENT NATIVE FORM REDIRECTION
    ======================================== */

    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (submitBtn) {
            addToCart(
              submitBtn
            );
          }

          return false;
        }
      );
    }

    var stickyAddButton =
      document.querySelector(
        '[data-kb-stick-add]'
      );

    if (stickyAddButton) {
      stickyAddButton.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          addToCart(
            stickyAddButton
          );
        }
      );
    }

    /* ========================================
       GALLERY
    ======================================== */

    var thumbs =
      document.querySelectorAll(
        '[data-kb-thumb]'
      );

    var slides =
      document.querySelectorAll(
        '.kb-stage .kb-slide'
      );

    var countEl =
      document.querySelector(
        '[data-kb-count]'
      );

    thumbs.forEach(
      function (thumbnail) {
        thumbnail.addEventListener(
          'click',
          function () {
            var index =
              parseInt(
                thumbnail.getAttribute(
                  'data-kb-thumb'
                ),
                10
              );

            thumbs.forEach(
              function (item) {
                item.setAttribute(
                  'aria-selected',
                  'false'
                );
              }
            );

            thumbnail.setAttribute(
              'aria-selected',
              'true'
            );

            slides.forEach(
              function (
                slide,
                slideIndex
              ) {
                slide.hidden =
                  slideIndex !==
                  index;
              }
            );

            if (countEl) {
              countEl.textContent =
                index + 1;
            }
          }
        );
      }
    );

    /* ========================================
       STICKY BAR
    ======================================== */

    var buyBox =
      document.querySelector(
        '.kb-buy'
      );

    if (stick && buyBox) {
      stick.hidden = false;

      var handleScroll =
        function () {
          stick.setAttribute(
            'data-on',
            buyBox
              .getBoundingClientRect()
              .bottom < 0
              ? 'true'
              : 'false'
          );
        };

      window.addEventListener(
        'scroll',
        handleScroll,
        {
          passive: true
        }
      );

      handleScroll();
    }

    render();

    /*
      Refresh once after initialization so that
      cached header/drawer content cannot remain stale.
    */
    window.setTimeout(
      function () {
        if (
          typeof syncCartInterface ===
          'function'
        ) {
          syncCartInterface();
        }
      },
      100
    );
  }

  /* ========================================
     INITIALIZATION
  ======================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initMattressPDP
    );
  } else {
    initMattressPDP();
  }

  /* ========================================
     BACK/FORWARD CACHE SYNCHRONIZATION
  ======================================== */

  window.addEventListener(
    'pageshow',
    function () {
      /*
        Always refresh on pageshow.

        This includes:
        - normal page load
        - browser Back
        - browser Forward
        - bfcache restoration
      */
      window.setTimeout(
        function () {
          if (
            typeof syncCartInterface ===
            'function'
          ) {
            syncCartInterface();
          }
        },
        50
      );
    }
  );

  /*
    Also synchronize when the shopper returns
    to this browser tab.
  */
  document.addEventListener(
    'visibilitychange',
    function () {
      if (
        document.visibilityState ===
          'visible' &&
        typeof syncCartInterface ===
          'function'
      ) {
        syncCartInterface();
      }
    }
  );
})();